const _ = require('lodash');

const TRANSLITERATION_EN_TO_RU = {
	A: 'А', B: 'В', E: 'Е', K: 'К', M: 'М', H: 'Н',
	O: 'О', P: 'Р', C: 'С', T: 'Т', X: 'Х', Y: 'У',
};
const TRANSLITERATION_RU_TO_EN = _.invert(TRANSLITERATION_EN_TO_RU);


const convertUtil = {
	transliterationEnToRu: function (string) {
		const enToRu = letter => TRANSLITERATION_EN_TO_RU[letter] || letter;
		return string && _.map(string.split(''), enToRu).join('');
	},

	transliterationRuToEn: function (string) {
		const ruToEn = letter => TRANSLITERATION_RU_TO_EN[letter] || letter;
		return string && _.map(string, ruToEn).join('');
	},

	normalizeDriverLicenseSeries: function (s) {
		return s && s.toUpperCase();
	},

	normalizeVehiclePassport: function (s) {
		return s && convertUtil.transliterationEnToRu(s.toUpperCase());
	},

	normalizeVehicleCertificate: function (s) {
		return s && convertUtil.transliterationEnToRu(s.toUpperCase());
	},

	normalizeVehicleBodyNumber: function (s) {
		return s && convertUtil.ignoreDashes(convertUtil.transliterationRuToEn(s.toUpperCase()));
	},

	normalizeRegNumber: function (regnum) {
		if (!regnum || 'string' != typeof regnum) {
			return regnum;
		}

		regnum = regnum.toUpperCase();

		regnum = convertUtil.transliterationEnToRu(regnum);

		regnum = convertUtil.trimWhitespaces(regnum);

		return regnum;
	},

	normalizePassport: function (regnum) {
		if (!regnum || 'string' != typeof regnum) {
			return regnum;
		}

		regnum = regnum.toUpperCase();
		regnum = convertUtil.transliterationEnToRu(regnum);
		return regnum;
	},

	normalizePromocode: function (promocode) {
		return convertUtil.transliterationRuToEn(promocode.toUpperCase());
	},

	toTitleCase: function (s) {
		s = String(s);
		return s[0].toUpperCase() + s.slice(1);
	},

	ignoreDashes: function (s) {
		return s ? s.replace(/-+/g, '') : s;
	},

	trimWhitespaces: function (s) {
		return s ? s.replace(/\s/g, '') : s;
	}
};

module.exports = convertUtil;
